<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Mobile menu overlay -->
    <div
      v-if="sidebarOpen"
      class="fixed inset-0 z-40 lg:hidden"
      @click="sidebarOpen = false"
    >
      <div class="fixed inset-0 bg-gray-600 bg-opacity-75"></div>
    </div>

    <!-- Mobile sidebar -->
    <div
      :class="[
        'fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out lg:hidden',
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      ]"
    >
      <div class="flex items-center justify-between h-16 px-4 border-b border-gray-200">
        <h1 class="text-lg font-semibold text-gray-900">VDM System</h1>
        <button
          @click="sidebarOpen = false"
          class="p-2 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100"
        >
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <NavigationMenu @navigate="sidebarOpen = false" />
    </div>

    <!-- Desktop sidebar -->
    <div class="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
      <div class="flex flex-col flex-grow bg-white border-r border-gray-200 shadow-sm">
        <div class="flex items-center h-16 px-4 border-b border-gray-200">
          <h1 class="text-xl font-bold text-gray-900">🚗 Pao VDM System</h1>
        </div>
        <NavigationMenu />
      </div>
    </div>

    <!-- Main content area -->
    <div class="lg:pl-64 flex flex-col flex-1">
      <!-- Header bar -->
      <HeaderBar @toggle-sidebar="sidebarOpen = !sidebarOpen" />
      
      <!-- Page content -->
      <main class="flex-1">
        <div class="py-6">
          <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <!-- Breadcrumb navigation -->
            <div class="mb-6">
              <BreadcrumbNavigation />
            </div>
            
            <!-- Page content slot -->
            <slot />
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import HeaderBar from './HeaderBar.vue'
import NavigationMenu from './NavigationMenu.vue'
import BreadcrumbNavigation from './BreadcrumbNavigation.vue'

const sidebarOpen = ref(false)
</script>